// extracted by mini-css-extract-plugin
export default {"cls1":"Icons-cls1___bbd5fef178e7423e7d0","cls2":"Icons-cls2___6d1a3099e1a1fc099a1 Icons-cls1___bbd5fef178e7423e7d0"};